<!--TODO temporary. will be refactored-->

<div
    cmpsSearchUser
    [pendingInit]="state?.pending?.init"
    [pendingSearch]="state?.pending?.search"
    [pendingSelectUser]="state?.pending?.selectUser"
    [teamColumns]="state?.teamColumns"
    [teamRows]="state?.teamRows"
    [teamSortDefs]="state?.teamSortDefs"
    [teamGridNeedsLayout]="state?.teamGridNeedsLayout"
    [favoritesColumns]="state?.favoritesColumns"
    [favoritesRows]="state?.favoritesRows"
    [favoritesSortDefs]="state?.favoritesSortDefs"
    [favoritesGridNeedsLayout]="state?.favoritesGridNeedsLayout"
    [parameterLookupOpts]="_parameterLookupOpts"
    [didInitialSearch]="state?.didInitialSearch"
    [searchFailed]="state?.searchFailed"
    [searchExceedsMaxCount]="state?.searchExceedsMaxCount"
    [searchColumns]="state?.searchColumns"
    [searchRows]="state?.searchRows"
    [searchSortDefs]="state?.searchSortDefs"
    [searchGridNeedsLayout]="state?.searchGridNeedsLayout"
    [selectedUser]="state?.selectedUser"
    [selectedUserManager]="state?.selectedUserManager"
    [hasSelfButton]="scope === _SecurityScope.COACHING"
    [statusOpts]="_statusOpts"
    [parameterOpts]="_parameterOpts"
    [form]="_form"
    (addParameter)="_onAddParameterClick()"
    (removeParameter)="_onRemoveParameterClick($event)"
    (searchClick)="_onSearchClick()"
    (userClick)="_onUserClick($event)"
    (toggleFavorite)="_onToggleFavorite($event)"
    (resetClick)="_onResetClick()"
    (searchGridSortChange)="_onSearchGridSortChange($event)"
    (selfClick)="_onSelfClick()"
    (selectClick)="_onSelectClick()"
></div>
